import angular from 'angular';

/**
 * @typedef {import('./types').PopupScope} PopupScope
 */

angular.module('popup').directive('popup', settingsPopup);

settingsPopup.$inject = ['$mdDialog'];

/** @type {angular.IDirectiveFactory<PopupScope & angular.IScope>} */
function settingsPopup(
  /** @type {angular.material.IDialogService} */ $mdDialog,
) {
  var directive = {
    bindToController: true,
    link: link,
    restrict: 'A',
    scope: {
      titleText: '@titleText',
      onCancel: '&onCancel',
      onBack: '&onBack',
      onSubmit: '&onSubmit',
      tmplUrl: '@tmplUrl',
      object: '=object',
      data: '=data',
      noClickOutside: '=noClickOutside',
    },
  };
  return directive;

  function link(
    /** @type {PopupScope & angular.IScope} */ scope,
    element,
    attrs,
  ) {
    element.bind('click', function (event) {
      scope.model = angular.copy(scope.object);

      $mdDialog.show(
        // @ts-expect-error - alert actually supports arguments
        // but this feature is not covered with types
        $mdDialog.alert({
          clickOutsideToClose: scope.noClickOutside ? false : true,
          targetEvent: event,
          parent: angular.element('body'),
          templateUrl: scope.tmplUrl
            ? scope.tmplUrl
            : new URL('app/popup/popup.html?raw', import.meta.url),
          controller: 'popupCtrl',
          controllerAs: 'vm',
          scope,
          preserveScope: true,
        }),
      );
    });
  }
}
